var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.54518 1.41126V2.15584H1.9901C1.30075 2.15584 0.898245 2.34105 0.59382 2.79822L0.376915 3.12396L0.355153 8.61115L0.333313 14.0983L0.530428 14.4953C0.648382 14.7328 0.844629 14.9708 1.01919 15.0881C1.29815 15.2755 1.37061 15.2851 2.67709 15.3087L4.04325 15.3333V14.6228V13.9124H2.93941H1.83557V9.83682V5.7612H6.99998H12.1644V9.83682V13.9124H11.0605H9.95671V14.6228V15.3333L11.3229 15.3087C12.6293 15.2851 12.7018 15.2755 12.9808 15.0881C13.1553 14.9708 13.3516 14.7328 13.4695 14.4953L13.6666 14.0983L13.6448 8.61115L13.623 3.12396L13.4061 2.79822C13.1017 2.34105 12.6992 2.15584 12.0099 2.15584H11.4548V1.41126V0.666672H10.7057H9.95671V1.41126V2.15584H6.99998H4.04325V1.41126V0.666672H3.29422H2.54518V1.41126ZM6.25094 10.2287V12.4233H5.1676H4.08425L5.54133 13.8732L6.9984 15.3232L8.43916 13.8928L9.87983 12.4625L8.81446 12.4407L7.74902 12.4189V10.2265V8.03414H6.99998H6.25094V10.2287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.6bd5a9ee17f5d14db3f3f713f01f2d0c.svg";
export { ForwardRef as ReactComponent };